"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var stimulus_1 = require("stimulus");
var DOWN_ARROW_CLASS = "fa-chevron-down";
var UP_ARROW_CLASS = "fa-chevron-up";
var CardController = /** @class */ (function (_super) {
    __extends(CardController, _super);
    function CardController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.connect = function () {
            if (!_this.hasToggleArrowTarget) {
                return;
            }
            _this.toggleArrowTarget && _this.toggleArrowTarget.addEventListener('click', _this.toggleMessage);
        };
        _this.toggleMessage = function () {
            var _a;
            if (!_this.messageBoxTarget) {
                return;
            }
            (0, jquery_1.default)("html,body").stop().animate({ scrollTop: (((_a = (0, jquery_1.default)(_this.element).offset()) === null || _a === void 0 ? void 0 : _a.top) || 100) - 100 }, { easing: "swing", duration: 500 });
            (0, jquery_1.default)(_this.messageBoxTarget).toggleClass("message-opened");
            if ((0, jquery_1.default)(_this.messageBoxTarget).hasClass("message-opened")) {
                _this.replaceClass(DOWN_ARROW_CLASS, UP_ARROW_CLASS);
            }
            else {
                _this.replaceClass(UP_ARROW_CLASS, DOWN_ARROW_CLASS);
            }
        };
        _this.replaceClass = function (before, after) {
            if (!_this.toggleArrowTarget) {
                return;
            }
            (0, jquery_1.default)(_this.toggleArrowTarget).removeClass(before);
            (0, jquery_1.default)(_this.toggleArrowTarget).addClass(after);
        };
        return _this;
    }
    CardController.targets = ['messageBox', 'toggleArrow'];
    return CardController;
}(stimulus_1.Controller));
exports.default = CardController;
